import { useState } from "react";
import { NavLink } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import LogoImg from "common/assets/logo/logo.svg";
import SideDrawer from "common/components/SideDrawer/SideDrawer";

import "./styles.scss";

type NavItem = { text: string; to: string; external?: boolean };

const navItems: NavItem[] = [
  { text: "Über uns", to: "/" },
  {
    text: "Jobs",
    to: "https://innovaforge.de/jobs/",
    external: true,
  },
  { text: "Kontakte", to: "/contacts" },
  { text: "Regeln", to: "/network-it-rules" },
];

function renderItem(
  item: NavItem,
  className: string,
  onClick?: () => void,
): JSX.Element {
  if (item.external) {
    return (
      <a
        key={item.to}
        className={className}
        href={item.to}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
      >
        {item.text}
      </a>
    );
  }
  return (
    <NavLink
      key={item.to}
      className={({ isActive }) =>
        isActive ? `${className} active` : className
      }
      to={item.to}
      end
      onClick={onClick}
    >
      {item.text}
    </NavLink>
  );
}

function Header() {
  const [open, setOpen] = useState<boolean>(false);

  const closeDrawer = () => setOpen(false);

  return (
    <>
      <header className="header container">
        <div className="header__leftContent">
          <NavLink to="/">
            <img className="header__logo" src={LogoImg} alt="NETWORKIT" />
          </NavLink>
        </div>
        <div className="header__nav">
          {navItems.map((item) => renderItem(item, "header__navItem"))}
        </div>
        <IconButton
          className="header__menuBtn"
          color="inherit"
          aria-label="Menü öffnen"
          onClick={() => setOpen(true)}
          edge="start"
        >
          <MenuIcon />
        </IconButton>
      </header>
      <SideDrawer open={open} onClose={closeDrawer}>
        {navItems.map((item) =>
          renderItem(item, "header__navItem", closeDrawer),
        )}
      </SideDrawer>
    </>
  );
}

export default Header;
